<nav class="breadcrumb-container" aria-label="breadcrumb">
  <ol class="breadcrumb-list flex flex-row">
    @for (crumb of visibleCrumbs; track crumb.label; let last = $last) {
      <li
        class="breadcrumb-item"
        >
        @if (!last) {
          <a [routerLink]="crumb.url" class="breadcrumb-link">{{
            crumb.label
          }}</a>
        }
        @if (last) {
          <span>{{ crumb.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
